var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"questions",attrs:{"src":"http://61.220.29.158:9000/ruishishu/subjects","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }